import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import EmailModal from './EmailModal';

/**
 * Komponent för standardepost och välkomstepost
 * Hanterar både vanlig e-post till teammedlemmar och "Kom igång"-meddelanden
 */
const StandardEpost = ({
  isOpen,
  onClose,
  recipient,
  recipientName,
  recipientType = 'Kund',
  subject = '',
  message = '',
  projectId,
  projectName = '',
  allRecipients = [],
  onEmailSent,
  showTeamMembers = false,
  initialEmailMode = 'regular' // 'regular' eller 'welcome' för "Kom igång"
}) => {
  const { user } = useAuth();
  
  // Bestäm om vi ska tillåta projektstatusändring för "Kom igång"-mail
  // Endast byggkonsulter ska kunna aktivera detta
  const allowChangeProjectStatus = user?.role === 'byggkonsult';
  
  return (
    <EmailModal
      isOpen={isOpen}
      onClose={onClose}
      recipient={recipient}
      recipientName={recipientName}
      senderName={user ? `${user.firstName} ${user.lastName}` : 'Användare'}
      recipientType={recipientType}
      subject={subject}
      message={message}
      projectId={projectId}
      projectName={projectName}
      allRecipients={allRecipients}
      showTeamMembers={showTeamMembers}
      onEmailSent={onEmailSent}
      changeProjectStatus={allowChangeProjectStatus}
      initialEmailMode={initialEmailMode}
    />
  );
};

export default StandardEpost; 